<div class="table-responsive">
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col" translate>NAME</th>
        <th scope="col" translate>AR_ITEMTYPECD4</th>
        <th scope="col" translate>AR_Q_KLASSID</th>
        <th scope="col" translate>AVAILABILITY</th>
        <th scope="col" translate>PRICE</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of mappedData">
        <td *ngIf="item.replacementId == null">
          <a (click)="goToDetail(item.product)" class="text-dark">
            <b>{{ item.id }}</b> <br />
            {{ item.name }}
          </a>
          <div class="small">{{ item.product.extra.ar?.artbeskrspec }}</div>
          <pre class="d-none">{{ item.product.extra.ar | json }}</pre>
          <!-- <p class="mt-2">
            <span class="d-block">{{ getProductSubTitle(item.product) | async }}</span>
            <span class="d-block">{{ getOptionName('atp4', 'itemtypedesc', item.product.extra.ar.itemtypecd4) }}
              <span *ngIf="item.product.extra.ar.q_klassid!=null">
                <span translate>CLASS</span>:
                {{ getOptionName('q_klass', 'q_klassdesc', item.product.extra.ar.q_klassid) }}
              </span>
            </span>

            <span class="d-block"
              *ngIf="!!item.product.extra.ar.q_bransleeff && !!item.product.extra.ar.q_vatgrepp && !!item.product.extra.ar.q_bullervarde && !!item.product.extra.ar.q_bullerklass">
              <span class="font-weight-bold" translate>EU_LABELING</span>:
              <span>{{ getOptionName('q_bransleeff', 'q_bransleeffdesc', item.product.extra.ar.q_bransleeff)}}/</span>
              <span>{{ getOptionName('q_vatgrepp', 'q_vatgreppdesc', item.product.extra.ar.q_vatgrepp)}}/</span>
              <span>{{ getOptionName('q_bullervarde', 'q_bullervardedesc', item.product.extra.ar.q_bullervarde)}}/</span>
              <span>{{ getOptionName('q_bullerklass', 'q_bullerklassdesc', item.product.extra.ar.q_bullerklass)}}</span>
            </span>
            <span class="d-block">{{ getProductDescription(item.product) | async }}</span>
          </p> -->
          <!-- <colmec-product-symbols [product]="item.product"></colmec-product-symbols> -->
        </td>
        <td *ngIf="item.replacementId != null">
          <span [ngbPopover]="popContent2" triggers="mouseenter" [autoClose]="'outside'">
            <a routerLink="/product/{{ item.id }}" class="text-red">
              {{ item.id }} <i class="fas fa-exclamation-triangle"></i>
            </a>
          </span>
          <ng-template #popContent2>
            <div class="row">
              <div class="col text-center">
                <span translate>PRODUCT_REPLACED_BY</span> <br />
                <a routerLink="/product/{{ item.id }}" class="text-dark">
                  {{ item.replacementId }}
                </a>
              </div>
            </div>
          </ng-template>
        </td>
        <td>
          <lib-gung-meta-output
            [horizontal]="true"
            [gungTranslate]="''"
            [suppressLabel]="true"
            [value]="item.product.extra.ar?.itemtypecd4"
            metadataTable="atp4"
            metaOptionName="itemtypedesc"
          ></lib-gung-meta-output>
        </td>
        <td>
          <lib-gung-meta-output
            [horizontal]="true"
            [gungTranslate]="''"
            [suppressLabel]="true"
            [value]="item.product.extra.ar.q_klassid"
            metadataTable="q_klass"
            metaOptionName="q_klassdesc"
          ></lib-gung-meta-output>
        </td>
        <td>
          <!-- <span *ngIf="item.price">
            <div *ngIf="item.price.customerGrossPrice.value != item.price.customerNetPrice.value">
              <div class="pb-1" translate>
                <span
                  translate>GROSS_PRICE</span>:&nbsp;{{item.price.customerGrossPrice.value | gungCurrency: item.price.customerGrossPrice.currencyCode}}
              </div>
              <div class="pb-1" translate>DISCOUNT
                <span
                  *ngIf="item.price.customerDiscountPercent !== 0">:&nbsp;(-{{item.price.customerDiscountPercent}}%)</span>
              </div>
            </div>

            <div class="pb-2" [class.d-none]="hidePrice">
              {{ getNetPriceLabel(item.product) | async }}:&nbsp;{{ getNetPriceValue(item.price) | gungCurrency: item.price.customerNetPrice.currencyCode}}
            </div>
          </span> -->

          <i class="fas fa-box product-availability-box-icon"></i>&nbsp;
          <lib-availability [availability]="item.availability"></lib-availability>
        </td>
        <td>
          <div class="pb-2" [class.d-none]="hidePrice">
            {{ getNetPriceLabel(item.product) | async }}:&nbsp;{{
              getNetPriceValue(item.price) | gungCurrency: item.price.customerNetPrice.currencyCode
            }}
          </div>
        </td>
        <td class="buy-btn-product-table">
          <colmec-buy-btn
            [product]="item.product"
            [id]="item.id"
            [minimumOrderQuantity]="item.packageSize"
            [stepAmount]="item.packageSize"
          >
          </colmec-buy-btn>
        </td>
      </tr>
    </tbody>
  </table>
</div>
